// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.how-to {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: flex-start;
  width: 100%;
}

.how-to--container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  max-width: var(--grid-max-width);
  gap: 56px;
  width: 100%;
}

.how-to--card {
  background: var(--color-primary-light-gray);
  border: 1px solid var(--color-primary-offwhite);
  border-radius: 24px;
  display: block;
  flex-wrap: wrap;
  padding: 36px;
}
.how-to--card .description {
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
  margin-top: 40px;
  width: 100%;
}
.how-to--card .title {
  align-items: center;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  width: 100%;
}
.how-to--card .title .btn-primary {
  border-radius: 24px;
  height: 40px;
  padding: 0px 24px;
  cursor: default;
  pointer-events: none;
}
.how-to--card .title p {
  font-weight: 700;
}
.how-to--card span {
  color: var(--color-primary-red);
}

.how-to--download {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 24px;
  width: fit-content;
}

.how-to--download .qr-code {
  width: 72px;
  height: 72px;
}

.how-to--download .p1-paragraph span {
  color: var(--color-primary-red);
}
.how-to--download .p1-paragraph span[data-mobile] {
  color: inherit;
}
.how-to--download [data-mobile="true"] {
  display: none;
}

.how-to--list--wrapper {
  width: 100%;
  position: relative;
}

.how-to--list {
  display: grid;
  gap: 32px;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  grid-auto-rows: 1fr;
  width: 100%;
  padding: 0 24px;
  scrollbar-width: none;
}

.how-to-dots {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  display: none;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}
.dot {
  width: 6px;
  height: 6px;
  margin: 0 5px;
  background: var(--color-contrast-gray);
  border-radius: 50%;
  cursor: pointer;
  transition: width ease-in 0.3s, height ease-in 0.3s, background ease-in 0.3s;
}
.dot.active {
  width: 8px;
  height: 8px;
  background: var(--color-primary-red);
}

@media (max-width: 768px) {
  .how-to--card {
    max-width: 240px;
    padding: 32px;
  }
  .how-to--card .title .btn-primary {
    height: 30px;
  }
  .how-to--card .title img {
    aspect-ratio: 1;
    height: 40px;
  }
  .how-to--card .description {
    gap: 24px;
    margin-top: 32px;
  }
  .how-to--card .description > .d1-disclaimer {
    font-size: 8px;
    font-weight: 400;
  }
  .how-to--card .description > h5 > strong {
    font-weight: 500;
  }
  .how-to--card .description > p,
  .how-to--card .description > p > span,
  .how-to--card .description > p > strong {
    font-size: var(--font-size-p3-paragraph);
  }

  .how-to-dots {
    display: flex;
  }

  .how-to--download {
    gap: 16px;
    text-align: center;
  }

  .how-to--download img {
    width: 50px;
  }
  .how-to--download .p1-paragraph {
    font-size: 14px;
    width: 100%;
  }
  .how-to--download .p1-paragraph span[data-mobile] {
    display: none;
  }
  .how-to--download [data-mobile="true"] {
    display: block;
  }
  .how-to--download [data-mobile="false"] {
    display: none;
  }
  .how-to--download .btn-primary {
    align-items: center;
    color: var(--color-primary-red);
    display: flex;
    justify-content: center;
    height: 48px;
    line-height: 1rem;
    padding: 12px 16px;
  }

  .how-to--list--wrapper {
    padding-bottom: 40px;
  }

  .how-to--list {
    display: inline-flex;
    overflow: hidden;
    overflow-x: auto;
    white-space: nowrap;
    width: 100%;
  }
  .how-to--list .how-to--card {
    display: inline-block;
    height: auto;
    min-width: 240px;
    white-space: normal;
  }
  .how-to--card .title p {
    font-size: 12px;
    font-weight: 600;
    line-height: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/scripts/components/howTo/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,gCAAgC;EAChC,SAAS;EACT,WAAW;AACb;;AAEA;EACE,2CAA2C;EAC3C,+CAA+C;EAC/C,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,aAAa;AACf;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,4DAA4D;EAC5D,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,4EAA4E;AAC9E;AACA;EACE,UAAU;EACV,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE;IACE,gBAAgB;IAChB,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;IACf,YAAY;EACd;EACA;IACE,SAAS;IACT,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;;;IAGE,wCAAwC;EAC1C;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;EACA;IACE,eAAe;IACf,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,+BAA+B;IAC/B,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;AACF","sourcesContent":[".how-to {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-content: flex-start;\n  width: 100%;\n}\n\n.how-to--container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  max-width: var(--grid-max-width);\n  gap: 56px;\n  width: 100%;\n}\n\n.how-to--card {\n  background: var(--color-primary-light-gray);\n  border: 1px solid var(--color-primary-offwhite);\n  border-radius: 24px;\n  display: block;\n  flex-wrap: wrap;\n  padding: 36px;\n}\n.how-to--card .description {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 32px;\n  margin-top: 40px;\n  width: 100%;\n}\n.how-to--card .title {\n  align-items: center;\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: space-between;\n  width: 100%;\n}\n.how-to--card .title .btn-primary {\n  border-radius: 24px;\n  height: 40px;\n  padding: 0px 24px;\n  cursor: default;\n  pointer-events: none;\n}\n.how-to--card .title p {\n  font-weight: 700;\n}\n.how-to--card span {\n  color: var(--color-primary-red);\n}\n\n.how-to--download {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  gap: 24px;\n  width: fit-content;\n}\n\n.how-to--download .qr-code {\n  width: 72px;\n  height: 72px;\n}\n\n.how-to--download .p1-paragraph span {\n  color: var(--color-primary-red);\n}\n.how-to--download .p1-paragraph span[data-mobile] {\n  color: inherit;\n}\n.how-to--download [data-mobile=\"true\"] {\n  display: none;\n}\n\n.how-to--list--wrapper {\n  width: 100%;\n  position: relative;\n}\n\n.how-to--list {\n  display: grid;\n  gap: 32px;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  grid-auto-rows: 1fr;\n  width: 100%;\n  padding: 0 24px;\n  scrollbar-width: none;\n}\n\n.how-to-dots {\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  display: none;\n  justify-content: center;\n  align-items: center;\n  margin-top: 10px;\n}\n.dot {\n  width: 6px;\n  height: 6px;\n  margin: 0 5px;\n  background: var(--color-contrast-gray);\n  border-radius: 50%;\n  cursor: pointer;\n  transition: width ease-in 0.3s, height ease-in 0.3s, background ease-in 0.3s;\n}\n.dot.active {\n  width: 8px;\n  height: 8px;\n  background: var(--color-primary-red);\n}\n\n@media (max-width: 768px) {\n  .how-to--card {\n    max-width: 240px;\n    padding: 32px;\n  }\n  .how-to--card .title .btn-primary {\n    height: 30px;\n  }\n  .how-to--card .title img {\n    aspect-ratio: 1;\n    height: 40px;\n  }\n  .how-to--card .description {\n    gap: 24px;\n    margin-top: 32px;\n  }\n  .how-to--card .description > .d1-disclaimer {\n    font-size: 8px;\n    font-weight: 400;\n  }\n  .how-to--card .description > h5 > strong {\n    font-weight: 500;\n  }\n  .how-to--card .description > p,\n  .how-to--card .description > p > span,\n  .how-to--card .description > p > strong {\n    font-size: var(--font-size-p3-paragraph);\n  }\n\n  .how-to-dots {\n    display: flex;\n  }\n\n  .how-to--download {\n    gap: 16px;\n    text-align: center;\n  }\n\n  .how-to--download img {\n    width: 50px;\n  }\n  .how-to--download .p1-paragraph {\n    font-size: 14px;\n    width: 100%;\n  }\n  .how-to--download .p1-paragraph span[data-mobile] {\n    display: none;\n  }\n  .how-to--download [data-mobile=\"true\"] {\n    display: block;\n  }\n  .how-to--download [data-mobile=\"false\"] {\n    display: none;\n  }\n  .how-to--download .btn-primary {\n    align-items: center;\n    color: var(--color-primary-red);\n    display: flex;\n    justify-content: center;\n    height: 48px;\n    line-height: 1rem;\n    padding: 12px 16px;\n  }\n\n  .how-to--list--wrapper {\n    padding-bottom: 40px;\n  }\n\n  .how-to--list {\n    display: inline-flex;\n    overflow: hidden;\n    overflow-x: auto;\n    white-space: nowrap;\n    width: 100%;\n  }\n  .how-to--list .how-to--card {\n    display: inline-block;\n    height: auto;\n    min-width: 240px;\n    white-space: normal;\n  }\n  .how-to--card .title p {\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 1rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
